import React, { useEffect, useState } from "react";
import MessengerLayout from "../../layout/MessengerLayout";
import { toast } from "../../components/ui/Toast";

const API = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card  = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const authH = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" });
const fmt   = n => `£${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

export default function BenefitsPage({ embedded = false } = {}) {
  const [enrolled, setEnrolled] = useState([]);
  const [schemes,  setSchemes]  = useState([]);
  const [window_,  setWindow]   = useState(null);
  const [busy, setBusy] = useState(null);
  const [msg,  setMsg]  = useState(null);

  const loadAll = async () => {
    const [e, s, w] = await Promise.all([
      fetch(`${API}/api/benefits/mine`,            { headers: authH() }).then(r => r.json()),
      fetch(`${API}/api/benefits/schemes`,         { headers: authH() }).then(r => r.json()),
      fetch(`${API}/api/benefits/window/current`,  { headers: authH() }).then(r => r.json()).catch(() => null),
    ]);
    setEnrolled(Array.isArray(e) ? e : []);
    setSchemes(Array.isArray(s) ? s : []);
    setWindow(w);
  };
  useEffect(() => { loadAll(); }, []);

  const enrol = async (schemeId) => {
    setBusy(schemeId); setMsg(null);
    try {
      const body = { scheme_id: schemeId };
      if (window_?.id) body.window_id = window_.id;
      const r = await fetch(`${API}/api/benefits/enrol`, { method: "POST", headers: authH(), body: JSON.stringify(body) });
      if (!r.ok) throw new Error((await r.json()).detail || "Failed");
      setMsg({ ok: true, text: "Enrolled" });
      toast.success("Enrolled in benefit");
      loadAll();
    } catch (e) { setMsg({ ok: false, text: e.message }); toast.error(e.message || "Failed to enrol"); }
    finally { setBusy(null); }
  };

  const optOut = async (schemeId) => {
    setBusy(schemeId);
    try {
      const r = await fetch(`${API}/api/benefits/opt-out`, { method: "POST", headers: authH(), body: JSON.stringify({ scheme_id: schemeId }) });
      if (!r.ok) throw new Error("Failed");
      toast.success("Opted out of benefit");
      loadAll();
    } catch (e) {
      toast.error("Failed to opt out");
    } finally { setBusy(null); }
  };

  const enrolledIds = new Set(enrolled.filter(e => e.status === "active").map(e => e.id));
  const available   = schemes.filter(s => !enrolledIds.has(s.id));

  const Wrapper = embedded ? React.Fragment : MessengerLayout;
  return (
    <Wrapper>
      <div className={embedded ? "space-y-5" : "max-w-4xl mx-auto p-6 space-y-5"}>
        <header className="space-y-1">
          {!embedded && <h1 className="text-xl font-semibold text-white">My Benefits</h1>}
          <p className="text-xs text-white/40">
            {window_ ? <>Enrolment window: <span className="text-[#00ff90]">{window_.name}</span> (closes {new Date(window_.closes_at).toLocaleDateString()})</>
                     : <>No open enrolment window. View existing schemes below.</>}
          </p>
        </header>

        <section>
          <h3 className="text-sm font-medium text-[#00ff90]/70 mb-2">Enrolled</h3>
          <div className="space-y-2">
            {enrolled.length === 0 ? <p className="text-white/40 text-sm italic p-3">Not enrolled in any schemes.</p>
              : enrolled.map(b => (
                <div key={b.id} className={`${card} p-4 flex items-center justify-between gap-3`}>
                  <div>
                    <p className="text-sm font-medium text-white/85">{b.name}</p>
                    <p className="text-xs text-white/40">{b.provider} · {b.benefit_type} · You: {fmt(b.employee_cost)}/{b.frequency}</p>
                    <span className={`text-xs px-2 py-0.5 rounded-full border mt-1 inline-block ${b.status === "active" ? "border-[#00ff90]/30 bg-[#00ff90]/10 text-[#00ff90]" : "border-white/10 text-white/40"}`}>
                      {b.status}
                    </span>
                  </div>
                  {b.status === "active" && (
                    <button onClick={() => optOut(b.id)} disabled={busy === b.id}
                      className="text-xs px-3 py-1.5 rounded border border-red-500/30 bg-red-500/10 text-red-400 hover:bg-red-500/20">Opt out</button>
                  )}
                </div>
              ))}
          </div>
        </section>

        {window_ && available.length > 0 && (
          <section>
            <h3 className="text-sm font-medium text-[#00ff90]/70 mb-2">Available to enrol</h3>
            <div className="space-y-2">
              {available.map(s => (
                <div key={s.id} className={`${card} p-4 flex items-center justify-between gap-3`}>
                  <div>
                    <p className="text-sm font-medium text-white/85">{s.name}</p>
                    <p className="text-xs text-white/40">{s.provider} · {s.description}</p>
                    <p className="text-xs text-white/40 mt-1">You pay: {fmt(s.employee_cost)}/{s.frequency} · Employer: {fmt(s.employer_cost)}</p>
                  </div>
                  <button onClick={() => enrol(s.id)} disabled={busy === s.id}
                    className="text-xs px-3 py-1.5 rounded border border-[#00ff90]/40 bg-[#00ff90]/10 text-[#00ff90] hover:bg-[#00ff90]/20">
                    {busy === s.id ? "Enrolling…" : "Enrol"}
                  </button>
                </div>
              ))}
            </div>
          </section>
        )}
        {msg && <p className={`text-xs ${msg.ok ? "text-[#00ff90]" : "text-red-400"}`}>{msg.text}</p>}
      </div>
    </Wrapper>
  );
}
